<template>
  <div class="page-wrapper">
    <!-- 装饰性模糊背景圆 -->
    <div class="bg-deco bg-deco-left"></div>
    <div class="bg-deco bg-deco-right"></div>

    <div class="page-container">
      <PageHeader :title="config.pageTitle" subtitle="" @back="goBack" />



      <!-- 基本信息（可折叠，默认折叠） -->
      <div class="symptom-section basic-info-section">
        <el-collapse v-model="basicInfoActiveNames" class="symptom-collapse basic-info-collapse">
          <el-collapse-item name="basicInfo">
            <template slot="title">
              <div class="collapse-title-bar">
                <span class="collapse-accent"></span>
                <span class="collapse-title-text">基本信息</span>
                <span class="collapse-hint" v-if="!basicInfoExpanded">点击展开</span>
              </div>
            </template>
            <div class="basic-info-content" v-if="consultInfo">
              <div class="info-item">
                <span class="info-label">姓名：</span>
                <span class="info-value">{{ consultInfo.name }}</span>
              </div>
              <div class="info-item">
                <span class="info-label">性别：</span>
                <span class="info-value">{{ consultInfo.sex == '1' ? '男' : '女' }}</span>
              </div>
              <div class="info-item" v-if="consultInfo.phoneNo">
                <span class="info-label">电话：</span>
                <span class="info-value">{{ consultInfo.phoneNo }}</span>
              </div>
              <div class="info-item">
                <span class="info-label">出生日期：</span>
                <span class="info-value">
                  {{ consultInfo.birthday }}<span v-if="shouldShowTime(consultInfo.birthHour, consultInfo.birthMinute)">
                    {{
                      formatTimeValue(consultInfo.birthHour) }}:{{ formatTimeValue(consultInfo.birthMinute) }}</span>
                </span>
              </div>
              <div class="info-item" v-if="consultInfo.liveArea">
                <span class="info-label">常住地址：</span>
                <span class="info-value">{{ consultInfo.liveArea }}</span>
              </div>
              <div class="info-item" v-if="consultInfo.birthArea">
                <span class="info-label">出生地址：</span>
                <span class="info-value">{{ consultInfo.birthArea }}</span>
              </div>
              <div class="info-item" v-if="consultInfo.useDate">
                <span class="info-label">开始服药时间：</span>
                <span class="info-value">{{ consultInfo.useDate }}</span>
              </div>
              <div class="info-item"
                v-if="consultInfo.useDays || (config.showGanZhi && consultInfo.ganZhiPrescriptionHourRange)">
                <span class="info-label">{{ useDaysLabel }}：</span>
                <span class="info-value">{{ useDaysValue }}</span>
              </div>
              <div class="info-item" v-if="config.showGanZhi && illDay">
                <span class="info-label">发病时间：</span>
                <span class="info-value">{{ illDay }}</span>
              </div>
              <div class="info-item" v-if="config.showExtraBasicInfo && consultInfo.useInstructions">
                <span class="info-label">使用方法：</span>
                <span class="info-value">{{ consultInfo.useInstructions }}</span>
              </div>
              <div class="info-item" v-if="config.showExtraBasicInfo && consultInfo.taboo">
                <span class="info-label">禁忌：</span>
                <span class="info-value">{{ consultInfo.taboo }}</span>
              </div>
              <div class="info-item" v-if="config.showDiagnosisInfo && diagnosisType">
                <span class="info-label">诊断类型：</span>
                <span class="info-value">{{ diagnosisType }}</span>
              </div>
              <div class="info-item" v-if="config.showDiagnosisInfo && diagnoseResult">
                <span class="info-label">诊断结果：</span>
                <span class="info-value">{{ diagnoseResult }}</span>
              </div>
              <div class="info-item" v-if="config.showDiagnosisInfo && takeMedTime">
                <span class="info-label">服药时间：</span>
                <span class="info-value">{{ takeMedTime }}</span>
              </div>
            </div>
            <div v-else class="text-muted">加载中...</div>
          </el-collapse-item>
        </el-collapse>
      </div>

      <!-- 症状信息（可折叠，默认折叠） -->
      <div class="symptom-section" v-if="config.showSymptoms && hasSymptomData">
        <el-collapse v-model="symptomActiveNames" class="symptom-collapse">
          <el-collapse-item name="symptoms">
            <template slot="title">
              <div class="collapse-title-bar">
                <span class="collapse-accent"></span>
                <span class="collapse-title-text">症状信息</span>
                <span class="collapse-hint" v-if="!symptomExpanded">点击展开</span>
              </div>
            </template>
            <div class="symptom-list">
              <!-- 基本情况/脉象 -->
              <div class="symptom-group" v-if="filteredBasicTableArray.length > 0">
                <div class="symptom-group-title">基本情况 / 脉象</div>
                <div class="symptom-info-grid">
                  <div class="info-item" v-for="item in filteredBasicTableArray" :key="item.key">
                    <span class="info-label">{{ item.key }}：</span>
                    <span class="info-value">{{ formatSymptomValue(item.value) }}</span>
                  </div>
                </div>
              </div>

              <!-- 三焦辨证 -->
              <template
                v-if="filteredShangjiaoTableArray.length > 0 || filteredZhongjiaoTableArray.length > 0 || filteredXiajiaoTableArray.length > 0">
                <div class="divider" v-if="filteredBasicTableArray.length > 0"></div>
                <div class="symptom-group">
                  <div class="symptom-group-title">三焦辨证</div>
                  <div class="sanjiao-list">
                    <div class="sanjiao-group" v-if="filteredShangjiaoTableArray.length > 0">
                      <div class="sanjiao-group-title">上焦</div>
                      <div class="symptom-info-grid">
                        <div class="info-item" v-for="item in filteredShangjiaoTableArray" :key="item.key">
                          <span class="info-label">{{ item.key }}：</span>
                          <span class="info-value">{{ formatSymptomValue(item.value) }}</span>
                        </div>
                      </div>
                    </div>
                    <div class="sanjiao-group" v-if="filteredZhongjiaoTableArray.length > 0">
                      <div class="sanjiao-group-title">中焦</div>
                      <div class="symptom-info-grid">
                        <div class="info-item" v-for="item in filteredZhongjiaoTableArray" :key="item.key">
                          <span class="info-label">{{ item.key }}：</span>
                          <span class="info-value">{{ formatSymptomValue(item.value) }}</span>
                        </div>
                      </div>
                    </div>
                    <div class="sanjiao-group" v-if="filteredXiajiaoTableArray.length > 0">
                      <div class="sanjiao-group-title">下焦</div>
                      <div class="symptom-info-grid">
                        <div class="info-item" v-for="item in filteredXiajiaoTableArray" :key="item.key">
                          <span class="info-label">{{ item.key }}：</span>
                          <span class="info-value">{{ formatSymptomValue(item.value) }}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </template>
            </div>
          </el-collapse-item>
        </el-collapse>
      </div>
      <!-- Tab 古中医组方 内容区 -->
      <div class="main-right" v-if="config.showMainTabCard === false">
        <section class="tab-card">
          <!-- Tab 切换栏（由接口 groups 动态生成） -->
          <div class="tab-bar" v-if="groupedTabsList.length > 0">
            <div class="tab-buttons">
              <button v-for="tab in groupedTabsList" :key="tab.label"
                :class="['tab-pill', { 'tab-pill-active': activeGroupedTab === tab.label }]"
                @click="switchGroupedTab(tab.label, tab.type)">{{ tab.label}}</button>
            </div>
          </div>

          <!-- 当前分组内容 -->
          <template v-if="currentGroup">
            <!-- 伤寒方（特殊渲染） -->
            <div v-if="currentGroup.isShangHan" class="tab-content">
              <div class="shanghan-info">
                <div class="shanghan-item"><b>发病时间：</b>{{ groupedIllDay }}</div>
                <pre class="shanghan-brief">{{ shangHanText }}</pre>
              </div>
            </div>

            <!-- 其他分组（月方/日方/时方/颗粒方） -->
            <div v-else class="tab-content">
              <el-tabs class="sub-tabs" v-model="groupedTabSubActive" v-if="currentGroup.items.length > 0">
                <el-tab-pane v-for="(pane, index) in currentGroup.items" :key="'grp-' + index" :label="pane.title"
                  :name="index.toString()">
                  <!-- <div class="drug-sub-header">
                    <div>
                      <p class="drug-sub-count">共 {{ pane.count }} 味 · {{ pane.totalWeight }} 克</p>
                      <p class="drug-sub-count" v-if="pane.disease">诊断结果：{{ pane.disease }}</p>
                    </div>
                    <div class="drug-price-badge" v-if="pane.charge != 0">参考药价：{{ pane.charge }}元/副</div>
                  </div> -->
                  <PrescriptionTable :pane="pane" :consultInfo="consultInfo" :config="config"
                    @drug-change="drugChangeClick" @drug-weight="drugWeightClick" />
                </el-tab-pane>
              </el-tabs>
              <div v-else class="text-muted empty-tab">暂无{{ currentGroup.label }}信息</div>
            </div>
          </template>

          <!-- 无任何分组数据 -->
          <div v-else class="text-muted empty-tab">暂无处方信息</div>
        </section>
      </div>



      <!-- Tab 通用方和自拟组方 内容区 -->
      <div class="main-right" v-if="config.showMainTabCard !== false">
        <section class="tab-card">
          <!-- Tab 切换栏 -->
          <div class="tab-bar">
            <div class="tab-buttons">
              <button v-for="tab in config.tabs" :key="tab"
                :class="['tab-pill', { 'tab-pill-active': activeTab === tab }]" @click="switchTab(tab)">{{ tab
                }}</button>
            </div>
          </div>

          <!-- 开方信息 -->
          <div v-if="activeTab === '开方信息'" class="tab-content">
            <el-tabs class="sub-tabs" v-model="tabActive" v-if="tablePrescription.length > 0">
              <el-tab-pane v-for="(pane, index) in tablePrescription" :key="'pres-' + index" :label="pane.title"
                :name="index.toString()">
                <!-- <div class="drug-sub-header">
                  <div>
                    <p class="drug-sub-count" v-if="config.showDiagnosisInfo">共 {{ pane.count }} 味 · {{ pane.totalWeight
                      }} 克
                    </p>
                    <p class="drug-sub-count" v-if="config.showDiagnosisInfo && diagnoseResult">诊断结果：{{ diagnoseResult
                      }}</p>
                    <p class="drug-sub-count" v-if="config.showDiagnosisInfo && takeMedTime">服药时间：{{ takeMedTime }}</p>
                  </div>
                  <div class="drug-price-badge" v-if="config.showDiagnosisInfo && pane.charge != 0">参考药价：{{ pane.charge
                    }}元/副
                  </div>
                </div> -->
                <PrescriptionTable :pane="pane" :consultInfo="consultInfo" :config="config"
                  @drug-change="drugChangeClick" @drug-weight="drugWeightClick" />
              </el-tab-pane>
              <el-tab-pane v-if="config.hasShanghanTab && shangHanPrescriptionInfos.functions" label="伤寒方" name="伤寒方">
                <div class="shanghan-info">
                  <div class="shanghan-item"><b>发病时间：</b>{{ illDay }}</div>
                  <pre class="shanghan-brief">{{ shangHanPrescriptionInfos.functions.shanghan.brief }}</pre>
                </div>
              </el-tab-pane>
            </el-tabs>
            <div v-else class="text-muted empty-tab">暂无开方信息</div>
          </div>

          <!-- 通用方信息 -->
          <div v-if="activeTab === '通用方信息'" class="tab-content">
            <el-tabs class="sub-tabs" v-model="tabActive2" v-if="tablePrescription2.length > 0">
              <el-tab-pane v-for="(pane, index) in tablePrescription2" :key="'gen-' + index" :label="pane.title"
                :name="index.toString()">
                <PrescriptionTable :pane="pane" :consultInfo="consultInfo" :config="config"
                  @drug-change="drugChangeClick" @drug-weight="drugWeightClick" />
              </el-tab-pane>
            </el-tabs>
            <div v-else class="text-muted empty-tab">暂无通用方信息</div>
          </div>

          <!-- 针灸信息 -->
          <div v-if="activeTab === '针灸信息'" class="info-content">
            <div class="corner-borders">
              <span class="corner corner-lt"></span>
              <span class="corner corner-rt"></span>
              <span class="corner corner-lb"></span>
              <span class="corner corner-rb"></span>
              <div class="corner-inner">
                <p v-for="(item, index) in resultsZJYC" :key="'zj-' + index"><span>{{ item }}</span></p>
                <div v-if="!resultsZJYC || resultsZJYC.length === 0" class="text-muted">暂无针灸信息</div>
              </div>
            </div>
          </div>

          <!-- 健康预测信息 -->
          <div v-if="activeTab === '健康预测信息'" class="info-content">
            <div class="corner-borders">
              <span class="corner corner-lt"></span>
              <span class="corner corner-rt"></span>
              <span class="corner corner-lb"></span>
              <span class="corner corner-rb"></span>
              <div class="corner-inner">
                <p v-for="(item, index) in resultsJKYC" :key="'jk-' + index"><span>{{ item }}</span></p>
                <div v-if="!resultsJKYC || resultsJKYC.length === 0" class="text-muted">暂无健康预测信息</div>
              </div>
            </div>
          </div>
        </section>
      </div>

      <!-- 底部操作栏 -->
      <div class="bottom-actions" v-if="showAiButton || showGenerateButton">
        <button class="btn-bottom-draft" v-if="showAiButton" @click="sendPrescriptionToAi"
          :disabled="!hasPrescriptionData">
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"
            stroke-linecap="round" stroke-linejoin="round">
            <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" />
          </svg>
          一键输入到AI对话框
        </button>
        <button class="btn-bottom-submit" v-if="showGenerateButton" @click="submit">
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"
            stroke-linecap="round" stroke-linejoin="round">
            <polyline points="20 6 9 17 4 12" />
          </svg>
          生成处方
        </button>
      </div>
    </div>

    <!-- 更换药方弹窗 -->
    <el-dialog title="更换药方" :visible.sync="dialogDrugVisible" center destroy-on-close width="360px">
      <div class="dialog-radio-list">
        <el-radio class="dialog-radio" v-for="drug in changeDrugList" v-model="currentDrug" :label="drug" :key="drug">{{
          drug }}</el-radio>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogDrugVisible = false" size="medium">取 消</el-button>
        <el-button type="primary" @click="dialogConfirm" size="medium">修 改</el-button>
      </div>
    </el-dialog>

    <!-- 更换重量弹窗 -->
    <el-dialog title="更换重量" :visible.sync="dialogWeightVisible" center destroy-on-close width="360px">
      <div class="dialog-weight-row">
        <span class="weight-drug-name">{{ flag == 0 ? currentItem.key : currentItem.key1 }}</span>
        <el-input-number v-model="currentWeight" @change="numberChange" :min="1" :max="999"
          :label="flag == 0 ? currentItem.key : currentItem.key1" size="small"></el-input-number>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogWeightVisible = false" size="medium">取 消</el-button>
        <el-button type="primary" @click="dialogWeightConfirm" size="medium">修 改</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import PrescriptionCard from './PrescriptionCard.vue'
import PrescriptionTable from './PrescriptionTable.vue'
import PageHeader from '@/components/widgets/PageHeader.vue'
import { EventBus } from '@/js/eventbus.js'
import utils from '@/js/utils.js'

export default {
  name: 'PrescriptionPage',
  components: { PrescriptionCard, PageHeader, PrescriptionTable },
  props: {
    config: {
      type: Object,
      default: () => ({
        pageTitle: '处方信息',
        fetchApi: '/api/health/v2/prescription',
        relRecordApi: '/api/health/v2/rela/record',
        replaceApi: '/api/health/v1/prescription/replace',
        replaceSubmitApi: '/api/health/v1/prescription/replace/submit',
        replaceResultApi: '/api/health/v1/prescription',
        showSymptoms: false,
        showGanZhi: false,
        tabs: ['开方信息', '针灸信息', '健康预测信息'],
        showAiButtonOnAllTabs: false,
        showGenerateOnAllPrescriptionTabs: false,
        hasShanghanTab: false,
        generateRoute: '/prescriptionImage',
        showExtraBasicInfo: false,
        showDiagnosisInfo: false,
        showGranules: false,
        showMainTabCard: true,
        useGroupedApi: false,
        fetchGroupedApi: '',
        showHandmadeSummary: false,
      }),
    },
  },
  data() {
    return {
      tabActive: '0',
      tabActive2: '0',
      activeTab: '',
      activeGroupedTab: '',
      groupedTabsList: [],
      groupedIllDay: '',
      groupedTabSubActive: '0',
      prescriptions: [],
      tablePrescription: [],
      tablePrescription2: [],
      changeDrugList: [],
      shangHanPrescriptionInfos: {},
      illDay: '',
      dialogDrugVisible: false,
      dialogWeightVisible: false,
      currentDrug: '',
      currentWeight: '',
      currentItem: {},
      flag: 0,
      basicTableArray: [],
      shangjiaoTableArray: [],
      zhongjiaoTableArray: [],
      xiajiaoTableArray: [],
      consultInfo: {},
      resultsZJYC: null,
      resultsJKYC: null,
      resultsTYF: null,
      TYvisitRecordId: '',
      paySuccessImage: '/static/image/ic_pay_success.png',
      visitRecordId: '',
      patientId: '',
      symptomActiveNames: [],
      basicInfoActiveNames: [],
      diagnosisType: '',
      activeGroupedTabID : ''
    }
  },
  computed: {
    useDaysLabel() {
      if (!this.config.showGanZhi) return '服药天数'
      return this.consultInfo.ganZhiPrescriptionHourRange ? '服药时间段' : '服药天数'
    },
    useDaysValue() {
      if (this.config.showGanZhi && this.consultInfo.ganZhiPrescriptionHourRange) {
        return this.consultInfo.ganZhiPrescriptionHourRange
      }
      return this.consultInfo.useDays
    },
    currentGroup() {
      if (!this.activeGroupedTab || this.groupedTabsList.length === 0) return null
      return this.groupedTabsList.find(g => g.label === this.activeGroupedTab) || null
    },
    hasPrescriptionData() {
      if (this.config.useGroupedApi) {
        const group = this.currentGroup
        if (!group) return false
        return group.items && group.items.length > 0
      }
      if (this.activeTab === '开方信息') {
        const hasRegular = this.tablePrescription && this.tablePrescription.length > 0
        const hasShanghan = this.config.hasShanghanTab && this.shangHanPrescriptionInfos && this.shangHanPrescriptionInfos.functions && this.shangHanPrescriptionInfos.functions.shanghan
        if (this.tabActive === '伤寒方') return hasShanghan
        return hasRegular
      }
      if (this.activeTab === '通用方信息') {
        return this.tablePrescription2 && this.tablePrescription2.length > 0
      }
      if (this.activeTab === '健康预测信息') {
        return this.resultsJKYC && this.resultsJKYC.length > 0
      }
      if (this.activeTab === '针灸信息') {
        return this.resultsZJYC && this.resultsZJYC.length > 0
      }
      return false
    },
    hasShangJiao() { return this.shangjiaoTableArray && this.shangjiaoTableArray.length > 0 },
    hasZhongJiao() { return this.zhongjiaoTableArray && this.zhongjiaoTableArray.length > 0 },
    hasXiaJiao() { return this.xiajiaoTableArray && this.xiajiaoTableArray.length > 0 },
    hasSymptomData() {
      return this.basicTableArray.length > 0 || this.shangjiaoTableArray.length > 0 || this.zhongjiaoTableArray.length > 0 || this.xiajiaoTableArray.length > 0
    },
    filteredBasicTableArray() {
      return this.filterSymptomItems(this.basicTableArray)
    },
    filteredShangjiaoTableArray() {
      return this.filterSymptomItems(this.shangjiaoTableArray)
    },
    filteredZhongjiaoTableArray() {
      return this.filterSymptomItems(this.zhongjiaoTableArray)
    },
    filteredXiajiaoTableArray() {
      return this.filterSymptomItems(this.xiajiaoTableArray)
    },
    symptomExpanded() {
      return this.symptomActiveNames && this.symptomActiveNames.includes('symptoms')
    },
    basicInfoExpanded() {
      return this.basicInfoActiveNames && this.basicInfoActiveNames.includes('basicInfo')
    },
    showAiButton() {
      if (this.config.useGroupedApi) return true
      if (this.config.showAiButtonOnAllTabs) return true
      return this.activeTab === '开方信息' || this.activeTab === '通用方信息' || this.activeTab === '健康预测信息' || this.activeTab === '针灸信息'
    },
    showGenerateButton() {
      if (this.config.useGroupedApi) {
        // 伤寒方不支持生成处方
        const group = this.currentGroup
        if (group && group.isShangHan) return false
        return true
      }
      if (this.config.showGenerateOnAllPrescriptionTabs) {
        return this.activeTab === '开方信息' || this.activeTab === '通用方信息'
      }
      return this.activeTab === '开方信息'
    },
    diagnoseResult() {
      if (this.config.useGroupedApi && this.activeGroupedTab) {
        const group = this.currentGroup
        if (group && !group.isShangHan && group.items && group.items.length > 0) {
          return group.items[0].disease || ''
        }
        return ''
      }
      if (this.tablePrescription && this.tablePrescription.length > 0) {
        return this.tablePrescription[0].disease || ''
      }
      return ''
    },
    takeMedTime() {
      if (this.config.useGroupedApi && this.activeGroupedTab) {
        const group = this.currentGroup
        if (group && !group.isShangHan && group.items && group.items.length > 0) {
          return group.items[0].takeTime || ''
        }
        return ''
      }
      if (this.tablePrescription && this.tablePrescription.length > 0) {
        return this.tablePrescription[0].takeTime || ''
      }
      return ''
    },
    shangHanText() {
      if (!this.config.useGroupedApi) return ''
      const group = this.currentGroup
      if (!group || !group.isShangHan || !group.items || !group.items[0]) return ''
      const sh = group.items[0]
      // 兼容两种结构：functions.prescription 或 functions.shanghan
      const content = (sh.functions && (sh.functions.prescription || sh.functions.shanghan)) || sh
      return content.brief || content.text || JSON.stringify(content, null, 2)
    },
  },
  created() {
    this.activeTab = this.config.tabs[0] || '开方信息'
    if (this.config.useGroupedApi) {
      this.activeGroupedTab = ''
    }
    this.visitRecordId = this.$route.query.visitRecordId
    this.patientId = this.$route.query.patientId
    this.fetchPrescriptionData()
  },
  methods: {
    switchTab(tab) {
      this.activeTab = tab
      this.changeType(tab)
    },
    shouldShowTime(hour, minute) {
      return !(this.isEmptyValue(hour) && this.isEmptyValue(minute))
    },
    isEmptyValue(value) {
      return value === '' || value === null || value === undefined
    },
    formatTimeValue(value) {
      if (value === '-1' || value === -1 || value === '--') return '--'
      return value
    },
    filterSymptomItems(arr) {
      if (!arr || arr.length === 0) return []
      return arr.filter(item => {
        if (!item || !item.value) return false
        const raw = Array.isArray(item.value) ? item.value.join('，') : String(item.value)
        const val = raw.trim()
        if (!val) return false
        if (val === '正常' || val === '无') return false
        return true
      })
    },
    formatSymptomValue(value) {
      if (Array.isArray(value)) value = value.join('，')
      return String(value).replace(/,/g, '，')
    },
    goBack() { this.$router.go(-1) },

    /* ======== 分组接口相关（古中医组方） ======== */

    generateGroupedTableData(data) {
      this.groupedTabsList = []
      this.groupedIllDay = data.illDay || ''

      if (!data.groups || !Array.isArray(data.groups) || data.groups.length === 0) {
        this.activeGroupedTab = ''
        return
      }

      for (const group of data.groups) {
        if (group.label === '伤寒方') {
          // 伤寒方：保持原始 JSON 透传
          if (group.list && group.list.length > 0) {
            this.groupedTabsList.push({
              label: '伤寒方',
              items: group.list,
              isShangHan: true,
            })
          }
        } else {
          // 月方/日方/时方/颗粒方：处理 PrescriptionInfo
          const panes = []
          for (const item of group.list) {
            const row = {
              isHandmade: !!this.config.showHandmadeSummary,
              count: item.count,
              charge: item.charge,
              totalWeight: item.totalWeight,
              decoctionTotalWeight: item.decoctionTotalWeight,
              decoctionPrice: item.decoctionPrice,
              startDate: item.startDate,
              endDate: item.endDate,
              supplyDays: item.supplyDays,
              title: item.name,
              granulesTotalWeight: item.granulesTotalWeight,
              granulesSumPrice: item.granulesSumPrice,
              takeTime: item.takeTime,
              disease: item.disease,
            }
            const itemArray = (item.prescription || []).map(drug => Object.assign({}, drug))
            const options = []
            for (let k = 0; k < itemArray.length; k += 2) {
              const left = itemArray[k] || {}
              const right = itemArray[k + 1]
              const pair = Object.assign({}, left)
              if (right && right.key != null && right.key !== '') {
                pair.key1 = right.key
                pair.value1 = right.value
                pair.index1 = right.index
              }
              options.push(pair)
            }
            row.options = options
            panes.push(row)
          }
          if (panes.length > 0) {
            this.groupedTabsList.push({
              label: group.label,
              type: group.type,
              items: panes,
              isShangHan: false,
            })
          }
        }
      }


      // 设置默认激活 tab
      if (this.groupedTabsList.length > 0) {
        this.activeGroupedTab = this.groupedTabsList[0].label
        this.activeGroupedTabID = this.groupedTabsList[0].type


      }
    },

    switchGroupedTab(label, type) {
      this.activeGroupedTab = label
      this.activeGroupedTabID = type
      console.log(this.activeGroupedTabID)
      this.groupedTabSubActive = '0'
    },

    fetchPrescriptionData() {
      // 分组接口路径（古中医组方）
      if (this.config.useGroupedApi && this.config.fetchGroupedApi) {
        this.wjtHttp.post(this, this.config.fetchGroupedApi, { visitRecordId: this.visitRecordId }, false,
          (res) => {
            const data = res.data
            if (data.code == 200) {
              this.consultInfo = data.data.patient
              this.consultInfo.useDate = data.data.startDate
              this.consultInfo.useDays = data.data.takeDays
              if (this.config.showGanZhi) {
                this.consultInfo.ganZhiPrescriptionTimeType = data.data.ganZhiPrescriptionTimeType
                this.consultInfo.ganZhiPrescriptionHourRange = data.data.takeHours
              }
              if (this.config.showSymptoms && data.data.inquiryInfo) {
                this.basicTableArray = [].concat(data.data.inquiryInfo.basic_array || [], data.data.inquiryInfo.basic_enter_array || [], data.data.inquiryInfo.maixiang_array || [])
                this.shangjiaoTableArray = data.data.inquiryInfo.shangjiao_array || []
                this.zhongjiaoTableArray = data.data.inquiryInfo.zhongjiao_array || []
                this.xiajiaoTableArray = data.data.inquiryInfo.xiajiao_array || []
              }
              this.generateGroupedTableData(data.data)
            } else {
              this.$message({ message: data.msg && data.msg.length > 0 ? data.msg : '出方异常，请联系管理员', type: 'error' })
            }
          },
          (err) => { console.log(err) }
        )
        return
      }

      // 旧接口路径（自拟组方/通用方）
      this.wjtHttp.post(this, this.config.fetchApi, { visitRecordId: this.visitRecordId }, false,
        (res) => {
          const data = res.data
          if (data.code == 200) {
            this.consultInfo = data.data.patient
            if (this.config.hasShanghanTab && data.data.shangHanPrescriptionInfos) {
              this.shangHanPrescriptionInfos = data.data.shangHanPrescriptionInfos
              this.illDay = data.data.illDay
            }
            this.consultInfo.useDate = data.data.startDate
            this.consultInfo.useDays = data.data.takeDays
            if (this.config.showGanZhi) {
              this.consultInfo.ganZhiPrescriptionTimeType = data.data.ganZhiPrescriptionTimeType
              this.consultInfo.ganZhiPrescriptionHourRange = data.data.takeHours
            }
            if (this.config.showExtraBasicInfo) {
              this.consultInfo.useInstructions = data.data.useInstructions
              this.consultInfo.taboo = data.data.taboo
            }
            if (this.config.showDiagnosisInfo) {
              this.diagnosisType = data.data.diagnosisType
            }
            if (this.config.showSymptoms && data.data.inquiryInfo) {
              this.basicTableArray = [].concat(data.data.inquiryInfo.basic_array || [], data.data.inquiryInfo.basic_enter_array || [], data.data.inquiryInfo.maixiang_array || [])
              this.shangjiaoTableArray = data.data.inquiryInfo.shangjiao_array || []
              this.zhongjiaoTableArray = data.data.inquiryInfo.zhongjiao_array || []
              this.xiajiaoTableArray = data.data.inquiryInfo.xiajiao_array || []
            }
            // 兼容新旧数据格式：
            // 旧格式：data.data.prescriptionInfos = [{prescription, count, ...}]
            // 新格式（commonPrescription 接口）：data.data.prescriptionInfos = []，实际数据在 data.data.commonPrescription
            this.prescriptions = (data.data.prescriptionInfos && data.data.prescriptionInfos.length > 0)
              ? data.data.prescriptionInfos
              : (data.data.commonPrescription ? [data.data.commonPrescription] : [])
            this.generateTableData()
          } else {
            this.$message({ message: data.msg && data.msg.length > 0 ? data.msg : '出方异常，请联系管理员', type: 'error' })
          }
        },
        (err) => { console.log(err) }
      )
    },

    changeType(tab) {
      if (tab == '针灸信息' && !this.resultsZJYC) this.getRecord('A')
      else if (tab == '健康预测信息' && !this.resultsJKYC) this.getRecord('D')
      else if (tab == '通用方信息' && !this.resultsTYF) this.getRecord('G')
    },

    getRecord(type) {
      const params = { relaVisitRecordId: this.visitRecordId, patientId: this.patientId, recordType: type, toDoDay: this.consultInfo.useDate, takeDays: this.consultInfo.useDays }
      this.wjtHttp.post(this, this.config.relRecordApi, params, false,
        (res) => {
          const data = res.data
          if (data.code == 200) {
            if (this.activeTab == '通用方信息') {
              // 兼容新旧数据格式
              this.resultsTYF = (data.data.prescriptionInfos && data.data.prescriptionInfos.length > 0)
                ? data.data.prescriptionInfos
                : (data.data.commonPrescription ? [data.data.commonPrescription] : [])
              this.TYvisitRecordId = data.data.visitRecordId
              this.generateTableData2()
              return
            }
            const rs = data.data.split('\n')
            const newRS = []
            rs.forEach((val) => { if (val.length != 0) newRS.push(val.replace(/ /g, '')) })
            if (this.activeTab == '针灸信息') this.resultsZJYC = newRS
            else if (this.activeTab == '健康预测信息') this.resultsJKYC = newRS
          } else {
            this.$message({ message: data.msg && data.msg.length > 0 ? data.msg : '出方异常，请联系管理员', type: 'error' })
          }
        },
        (err) => { console.log(err) }
      )
    },

    generateTableData() {
      this.tablePrescription = []
      for (let i = 0; i < this.prescriptions.length; i++) {
        const item = this.prescriptions[i]
        const row = { isHandmade: !!this.config.showHandmadeSummary, count: item.count, charge: item.charge, totalWeight: item.totalWeight, decoctionTotalWeight: item.decoctionTotalWeight, decoctionPrice: item.decoctionPrice, startDate: item.startDate, endDate: item.endDate, supplyDays: item.supplyDays, title: item.name, granulesTotalWeight: item.granulesTotalWeight, granulesSumPrice: item.granulesSumPrice, takeTime: item.takeTime, disease: item.disease }
        // 深拷贝处方数组，避免修改原始接口数据，并两两配对成一行
        const itemArray = (item.prescription || []).map(drug => Object.assign({}, drug))
        const options = []
        for (let k = 0; k < itemArray.length; k += 2) {
          const left = itemArray[k] || {}
          const right = itemArray[k + 1]
          const pair = Object.assign({}, left)
          if (right && right.key != null && right.key !== '') {
            pair.key1 = right.key
            pair.value1 = right.value
            pair.index1 = right.index
          }
          options.push(pair)
        }
        row.options = options
        this.tablePrescription.push(row)
      }
    },

    generateTableData2() {
      if (!this.resultsTYF) return
      this.tablePrescription2 = []
      for (let i = 0; i < this.resultsTYF.length; i++) {
        const item = this.resultsTYF[i]
        const row = { count: item.count, charge: item.charge, totalWeight: item.totalWeight, startDate: item.startDate, endDate: item.endDate, supplyDays: item.supplyDays, title: item.name }
        const itemArray = (item.prescription || []).map(drug => Object.assign({}, drug))
        const options = []
        for (let k = 0; k < itemArray.length; k += 2) {
          const left = itemArray[k] || {}
          const right = itemArray[k + 1]
          const pair = Object.assign({}, left)
          if (right && right.key != null && right.key !== '') {
            pair.key1 = right.key
            pair.value1 = right.value
            pair.index1 = right.index
          }
          options.push(pair)
        }
        row.options = options
        this.tablePrescription2.push(row)
      }
    },

    submit() {
      sessionStorage.setItem('consultInfo', JSON.stringify(this.consultInfo))
      if (this.config.showSymptoms) {
        sessionStorage.setItem('basicTable', JSON.stringify(this.basicTableArray))
        sessionStorage.setItem('shangjiaoTableArray', JSON.stringify(this.shangjiaoTableArray))
        sessionStorage.setItem('zhongjiaoTableArray', JSON.stringify(this.zhongjiaoTableArray))
        sessionStorage.setItem('xiajiaoTableArray', JSON.stringify(this.xiajiaoTableArray))
      }
      if (this.config.useGroupedApi) {
        // 古中医组方：保存当前分组数据
        const group = this.currentGroup
        const panes = group && !group.isShangHan ? (group.items || []) : []
        sessionStorage.setItem('tablePrescription', JSON.stringify(panes))
        this.$router.push({ path: this.config.generateRoute, query: { visitRecordId: this.visitRecordId, prescriptionType: this.activeGroupedTabID } })
        return
      }
      if (this.activeTab == '通用方信息') {
        sessionStorage.setItem('tablePrescription', JSON.stringify(this.tablePrescription2))
        this.$router.push({ path: this.config.generateRoute, query: { visitRecordId: this.TYvisitRecordId } })
      } else {
        sessionStorage.setItem('tablePrescription', JSON.stringify(this.tablePrescription))
        this.$router.push({ path: this.config.generateRoute, query: { visitRecordId: this.visitRecordId } })
      }
    },

    drugChangeClick(item, flag) {
      this.currentItem = item; this.flag = flag
      const subIdx = this.config.useGroupedApi ? parseInt(this.groupedTabSubActive) : parseInt(this.tabActive)
      const params = { patientId: this.patientId, visitRecordId: this.visitRecordId, medicineName: flag == 0 ? item.key : item.key1, number: subIdx + 1 }
      this.wjtHttp.post(this, this.config.replaceApi, params, false,
        (res) => {
          const data = res.data
          if (data.code == 200) {
            if (!utils.isEmptyStr(data.data.replaceMedicines)) {
              this.changeDrugList = data.data.replaceMedicines; this.currentDrug = ''; this.dialogDrugVisible = true
            } else { this.$message({ message: '无可更换药品', type: 'info' }) }
          } else { this.$message({ message: data.msg && data.msg.length > 0 ? data.msg : '无可更换药品', type: 'error' }) }
        },
        (err) => { console.log(err) }
      )
    },

    dialogConfirm() {
      if (utils.isEmptyStr(this.currentDrug)) { this.$message({ message: '请选择需要更换的药材', type: 'info' }); return }
      this.dialogDrugVisible = false
      const subIdx = this.config.useGroupedApi ? parseInt(this.groupedTabSubActive) : parseInt(this.tabActive)
      const params = { visitRecordId: this.visitRecordId, oldMedicineName: this.flag == 0 ? this.currentItem.key : this.currentItem.key1, replaceMedicineName: this.currentDrug, oldWeight: this.flag == 0 ? this.currentItem.value : this.currentItem.value1, replaceWeight: this.flag == 0 ? this.currentItem.value : this.currentItem.value1, number: subIdx + 1 }
      this.wjtHttp.post(this, this.config.replaceSubmitApi, params, false,
        (res) => {
          if (res.data.code == 200) this.refreshAfterReplace()
          else this.$message({ message: res.data.msg && res.data.msg.length > 0 ? res.data.msg : '更换药材失败', type: 'error' })
        },
        (err) => { console.log(err) }
      )
    },

    drugWeightClick(item, flag) {
      this.currentItem = item; this.flag = flag
      this.currentWeight = this.flag == 0 ? item.value : item.value1
      this.dialogWeightVisible = true
    },

    dialogWeightConfirm() {
      this.dialogWeightVisible = false
      const subIdx = this.config.useGroupedApi ? parseInt(this.groupedTabSubActive) : parseInt(this.tabActive)
      const params = { visitRecordId: this.visitRecordId, oldMedicineName: this.flag == 0 ? this.currentItem.key : this.currentItem.key1, replaceMedicineName: this.flag == 0 ? this.currentItem.key : this.currentItem.key1, oldWeight: this.flag == 0 ? this.currentItem.value : this.currentItem.value1, replaceWeight: this.currentWeight, number: subIdx + 1 }
      this.wjtHttp.post(this, this.config.replaceSubmitApi, params, false,
        (res) => {
          if (res.data.code == 200) this.refreshAfterReplace()
          else this.$message({ message: res.data.msg && res.data.msg.length > 0 ? res.data.msg : '修改重量异常，请联系管理员', type: 'error' })
        },
        (err) => { console.log(err) }
      )
    },

    refreshAfterReplace() {
      const api = this.config.replaceResultApi
      this.wjtHttp.post(this, api, { visitRecordId: this.visitRecordId }, false,
        (res) => {
          if (res.data.code == 200) {
            const result = res.data.data || res.data
            // 兼容新旧数据格式
            this.prescriptions = (result.prescriptionInfos && result.prescriptionInfos.length > 0)
              ? result.prescriptionInfos
              : (result.commonPrescription ? [result.commonPrescription] : [])
            this.generateTableData()
          }
          else this.$message({ message: res.data.msg && res.data.msg.length > 0 ? res.data.msg : '出方异常，请联系管理员', type: 'error' })
        },
        (err) => { console.log(err) }
      )
    },

    numberChange(value) { this.currentItem.newValue = value },

    parsePrescriptionToText() {
      const lines = []

      // 分组接口（古中医组方）
      if (this.config.useGroupedApi) {
        if (this.consultInfo && this.consultInfo.name) lines.push(`患者姓名：${utils.blurName(this.consultInfo.name)}`)
        if (this.consultInfo && this.consultInfo.birthday) {
          let text = `患者生日：${this.consultInfo.birthday}`
          if (this.shouldShowTime(this.consultInfo.birthHour, this.consultInfo.birthMinute)) text += ` ${this.formatTimeValue(this.consultInfo.birthHour)}:${this.formatTimeValue(this.consultInfo.birthMinute)}`
          lines.push(text)
        }
        if (this.consultInfo && this.consultInfo.birthArea) lines.push(`患者出生地址：${this.consultInfo.birthArea}`)
        if (this.consultInfo && this.consultInfo.liveArea) lines.push(`常住地址：${this.consultInfo.liveArea}`)
        if (this.consultInfo && (this.consultInfo.useDays || (this.config.showGanZhi && this.consultInfo.ganZhiPrescriptionHourRange))) {
          const label = this.useDaysLabel; const value = this.useDaysValue
          lines.push(`${label}：${value}`)
        }
        if (this.config.showSymptoms) {
          const symptoms = []
          if (this.basicTableArray) { for (const item of this.basicTableArray) { if (item.key && item.value && item.value.length > 0) symptoms.push(`${item.key}：${item.value}`) } }
          if (this.shangjiaoTableArray) { for (const item of this.shangjiaoTableArray) { if (item.key && item.value) symptoms.push(`上焦-${item.key}：${item.value}`) } }
          if (this.zhongjiaoTableArray) { for (const item of this.zhongjiaoTableArray) { if (item.key && item.value) symptoms.push(`中焦-${item.key}：${item.value}`) } }
          if (this.xiajiaoTableArray) { for (const item of this.xiajiaoTableArray) { if (item.key && item.value) symptoms.push(`下焦-${item.key}：${item.value}`) } }
          if (symptoms.length > 0) { lines.push(`症状信息：`); symptoms.forEach(s => lines.push(s)) }
        }
        // 使用 currentGroup 判断
        const group = this.currentGroup
        if (!group) { lines.push('药方内容：暂无处方数据'); return lines.join('\n') }
        // 伤寒方
        if (group.isShangHan) {
          const shData = group.items[0]
          const content = (shData && shData.functions && (shData.functions.prescription || shData.functions.shanghan))
          if (!content) { lines.push('药方内容：暂无伤寒方数据'); return lines.join('\n') }
          lines.push('药方内容：')
          lines.push(content.brief || content.text || '暂无详细描述')
          if (this.groupedIllDay) lines.push(`发病时间：${this.groupedIllDay}`)
          return lines.join('\n')
        }
        // 其他分组
        const panes = group.items
        if (!panes || panes.length === 0) { lines.push('药方内容：暂无处方数据'); return lines.join('\n') }
        const idx = parseInt(this.groupedTabSubActive)
        if (isNaN(idx) || idx < 0 || idx >= panes.length) { lines.push('药方内容：暂无处方数据'); return lines.join('\n') }
        const cp = panes[idx]
        if (!cp || !cp.options || cp.options.length === 0) {
          lines.push('药方内容：')
          lines.push('药材组成：暂无药材明细')
          lines.push(`总计：${cp.count || 0}味，${cp.totalWeight || 0}克`)
          lines.push(`使用期限：${cp.startDate || ''} 至 ${cp.endDate || ''}`)
          lines.push(`有效期：${cp.supplyDays || 0}天`)
          return lines.join('\n')
        }
        const herbs = []
        for (const h of cp.options) {
          if (h.key && h.value) herbs.push(`${h.key}${h.value}克`)
          if (h.key1 && h.value1) herbs.push(`${h.key1}${h.value1}克`)
        }
        lines.push('药方内容：')
        lines.push(`药材组成：${herbs.length > 0 ? herbs.join('，') : '暂无药材明细'}`)
        lines.push(`总计：${cp.count}味，${cp.totalWeight}克`)
        lines.push(`使用期限：${cp.startDate} 至 ${cp.endDate}`)
        lines.push(`有效期：${cp.supplyDays}天`)
        return lines.join('\n')
      }

      // 以下为旧接口逻辑（自拟组方/通用方）
      if (this.activeTab != '健康预测信息' && this.activeTab != '针灸信息') {
        if (this.consultInfo && this.consultInfo.name) lines.push(`患者姓名：${utils.blurName(this.consultInfo.name)}`)
        if (this.consultInfo && this.consultInfo.birthday) {
          let text = `患者生日：${this.consultInfo.birthday}`
          if (this.shouldShowTime(this.consultInfo.birthHour, this.consultInfo.birthMinute)) text += ` ${this.formatTimeValue(this.consultInfo.birthHour)}:${this.formatTimeValue(this.consultInfo.birthMinute)}`
          lines.push(text)
        }
        if (this.consultInfo && this.consultInfo.birthArea) lines.push(`患者出生地址：${this.consultInfo.birthArea}`)
        if (this.consultInfo && this.consultInfo.liveArea) lines.push(`常住地址：${this.consultInfo.liveArea}`)
        if (this.consultInfo && (this.consultInfo.useDays || (this.config.showGanZhi && this.consultInfo.ganZhiPrescriptionHourRange))) {
          const label = this.useDaysLabel; const value = this.useDaysValue
          lines.push(`${label}：${value}`)
        }
        if (this.config.showExtraBasicInfo) {
          if (this.consultInfo && this.consultInfo.useInstructions) lines.push(`使用方法：${this.consultInfo.useInstructions}`)
          if (this.consultInfo && this.consultInfo.taboo) lines.push(`禁忌：${this.consultInfo.taboo}`)
        }
        if (this.config.showDiagnosisInfo) {
          if (this.diagnosisType) lines.push(`诊断类型：${this.diagnosisType}`)
          if (this.diagnoseResult) lines.push(`诊断结果：${this.diagnoseResult}`)
          if (this.takeMedTime) lines.push(`服药时间：${this.takeMedTime}`)
        }
        if (this.config.showSymptoms) {
          const symptoms = []
          if (this.basicTableArray) {
            for (const item of this.basicTableArray) { if (item.key && item.value && item.value.length > 0) symptoms.push(`${item.key}：${item.value}`) }
          }
          if (this.shangjiaoTableArray) { for (const item of this.shangjiaoTableArray) { if (item.key && item.value) symptoms.push(`上焦-${item.key}：${item.value}`) } }
          if (this.zhongjiaoTableArray) { for (const item of this.zhongjiaoTableArray) { if (item.key && item.value) symptoms.push(`中焦-${item.key}：${item.value}`) } }
          if (this.xiajiaoTableArray) { for (const item of this.xiajiaoTableArray) { if (item.key && item.value) symptoms.push(`下焦-${item.key}：${item.value}`) } }
          if (symptoms.length > 0) { lines.push(`症状信息：`); symptoms.forEach(s => lines.push(s)) }
        }
      }
      if (this.activeTab === '健康预测信息') return this.parseHealthPredictionToText(lines)
      if (this.activeTab === '针灸信息') return this.parseAcupunctureToText(lines)
      if (this.activeTab === '开方信息' && this.tabActive === '伤寒方') {
        if (!this.shangHanPrescriptionInfos || !this.shangHanPrescriptionInfos.functions || !this.shangHanPrescriptionInfos.functions.shanghan) { lines.push('药方内容：暂无伤寒方数据'); return lines.join('\n') }
        lines.push('药方内容：')
        lines.push(this.shangHanPrescriptionInfos.functions.shanghan.brief || '暂无详细描述')
        if (this.illDay) lines.push(`发病时间：${this.illDay}`)
        return lines.join('\n')
      }
      const source = this.activeTab === '通用方信息' ? this.tablePrescription2 : this.tablePrescription
      const idx = this.activeTab === '通用方信息' ? parseInt(this.tabActive2) : parseInt(this.tabActive)
      if (!source || source.length === 0 || isNaN(idx) || idx < 0 || idx >= source.length) { lines.push('药方内容：暂无处方数据'); return lines.join('\n') }
      const cp = source[idx]
      if (!cp || !cp.options || cp.options.length === 0) {
        lines.push('药方内容：')
        lines.push('药材组成：暂无药材明细')
        lines.push(`总计：${cp.count || 0}味，${cp.totalWeight || 0}克`)
        lines.push(`使用期限：${cp.startDate || ''} 至 ${cp.endDate || ''}`)
        lines.push(`有效期：${cp.supplyDays || 0}天`)
        return lines.join('\n')
      }
      const herbs = []
      for (const h of cp.options) {
        if (h.key && h.value) herbs.push(`${h.key}${h.value}克`)
        if (h.key1 && h.value1) herbs.push(`${h.key1}${h.value1}克`)
      }
      lines.push('药方内容：')
      lines.push(`药材组成：${herbs.length > 0 ? herbs.join('，') : '暂无药材明细'}`)
      lines.push(`总计：${cp.count}味，${cp.totalWeight}克`)
      lines.push(`使用期限：${cp.startDate} 至 ${cp.endDate}`)
      lines.push(`有效期：${cp.supplyDays}天`)
      return lines.join('\n')
    },

    parseHealthPredictionToText(baseLines) {
      const lines = [...baseLines]
      if (!this.resultsJKYC || this.resultsJKYC.length === 0) { lines.push('健康预测信息：暂无数据'); return lines.join('\n') }
      lines.push('健康预测信息：')
      this.resultsJKYC.forEach(item => { if (item && item.trim()) lines.push(item) })
      return lines.join('\n')
    },

    parseAcupunctureToText(baseLines) {
      const lines = [...baseLines]
      if (!this.resultsZJYC || this.resultsZJYC.length === 0) { lines.push('针灸信息：暂无数据'); return lines.join('\n') }
      lines.push('针灸信息：')
      this.resultsZJYC.forEach(item => { if (item && item.trim()) lines.push(item) })
      return lines.join('\n')
    },

    sendPrescriptionToAi() {
      const text = this.parsePrescriptionToText()
      if (text.includes('暂无') || text.includes('异常') || text.includes('无效')) { this.$message.warning(text); return }
      let sourceType = 'prescription'
      let prescriptionType = this.activeTab
      if (this.config.useGroupedApi) {
        sourceType = 'prescription'
        prescriptionType = this.activeGroupedTab
      } else if (this.activeTab === '健康预测信息') {
        sourceType = 'health_prediction'
      } else if (this.activeTab === '针灸信息') {
        sourceType = 'acupuncture'
      } else if (this.activeTab === '通用方信息') {
        sourceType = 'general_prescription'
      }
      EventBus.$emit('ai-input-text', { text, source: sourceType, prescriptionType, patientName: this.consultInfo && this.consultInfo.name ? utils.blurName(this.consultInfo.name) : '' })
      this.$message.success('处方已填充到AI对话框，可以开始咨询')
    },
  },
}
</script>

<style scoped>
/* ========== 页面背景 ========== */
.page-wrapper {
  min-height: 100vh;
  background: #f4f9f5;
  position: relative;
  overflow: hidden;
  font-family: 'Noto Sans SC', system-ui, sans-serif;
}

/* 装饰模糊背景圆 */
.bg-deco {
  position: absolute;
  border-radius: 50%;
  pointer-events: none;
}

.bg-deco-left {
  left: -112px;
  top: 96px;
  width: 320px;
  height: 320px;
  background: rgba(42, 122, 75, 0.08);
  filter: blur(64px);
}

.bg-deco-right {
  right: 0;
  top: 0;
  width: 384px;
  height: 288px;
  background: rgba(200, 169, 110, 0.1);
  filter: blur(64px);
}

.page-container {
  position: relative;
  max-width: 1200px;
  margin: 0 auto;
  padding: 32px 24px 80px;
  z-index: 1;
}

/* ========== 顶部状态卡片 ========== */
.status-card {
  background: #ffffff;
  border: 1px solid #e0ebe4;
  border-radius: 32px;
  padding: 28px 36px;
  margin-bottom: 24px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.04);
}

.status-card-inner {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

@media (min-width: 768px) {
  .status-card-inner {
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
  }
}

.status-left {
  display: flex;
  align-items: center;
  gap: 16px;
}

.status-icon-circle {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 64px;
  height: 64px;
  border-radius: 50%;
  background: #f0f7f2;
  box-shadow: 0 0 0 8px #f8fbf9;
  flex-shrink: 0;
}

.status-info {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.status-badge {
  display: inline-flex;
  align-self: flex-start;
  border-radius: 9999px;
  background: #f0f7f2;
  padding: 4px 16px;
  font-size: 14px;
  font-weight: 600;
  color: #20863F;
}

.status-title {
  font-size: 30px;
  font-weight: 700;
  color: #123b25;
  margin: 0;
  line-height: 1.3;
}

.status-desc {
  font-size: 15px;
  color: #66756b;
  margin: 0;
}



/* ========== 主内容区 ========== */
.main-grid {
  display: flex;
  flex-direction: column;
  gap: 24px;
}

/* ========== 基本信息卡片（可折叠） ========== */
.basic-info-section {
  margin-top: 0;
  margin-bottom: 24px;
}

.basic-info-content {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 12px;
  padding: 4px 0;
}

.basic-info-content .info-item {
  display: flex;
  align-items: center;
  border: 1px solid #edf0ec;
  border-radius: 8px;
  padding: 10px 14px;
  font-size: 18px;
  line-height: 1.5;
  background: #fff;
}

.basic-info-content .info-label {
  color: #1a1a1a;
  flex-shrink: 0;
  font-size: 18px;
  min-width: 130px;
}

.basic-info-content .info-value {
  color: #1a1a1a;
  font-size: 18px;
  word-break: break-all;
}

@media (max-width: 640px) {
  .basic-info-content {
    grid-template-columns: 1fr;
  }
}

/* ========== 右侧：Tab 卡片 ========== */
.main-right {
  min-width: 0;
  display: flex;
  flex-direction: column;
}

.tab-card {
  background: #ffffff;
  border: 1px solid #e0ebe4;
  border-radius: 32px;
  padding: 24px 28px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.04);
  flex: 1;
}

/* Tab 切换栏 */
.tab-bar {
  display: flex;
  flex-direction: column;
  gap: 12px;
  border: 1px solid #edf2ee;
  border-radius: 24px;
  background: #fcfdfc;
  padding: 12px;
  margin-bottom: 24px;
}

@media (min-width: 768px) {
  .tab-bar {
    flex-direction: row;
    align-items: center;
    justify-content: center;
  }
}

.tab-buttons {
  display: flex;
  gap: 8px;
  overflow-x: auto;
  padding-bottom: 2px;
  margin: 0 auto;
}

.tab-pill {
  flex-shrink: 0;
  padding: 10px 22px;
  border-radius: 9999px;
  border: 1px solid #dfeae3;
  background: #ffffff;
  color: #55655b;
  font-size: 18px !important;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s;
  white-space: nowrap;
}

.tab-pill:hover {
  background: #f4f9f5;
}

.tab-pill-active {
  background: #20863F;
  color: #ffffff;
  border-color: #20863F;
  box-shadow: 0 1px 3px rgba(42, 122, 75, 0.2);
}

.tab-pill-active:hover {
  background: #21633d;
}



/* ========== 子 Tab（处方多标签） ========== */
.sub-tabs {
  width: 100%;
}

.sub-tabs>>>.el-tabs__header {
  margin-bottom: 16px;
}

.sub-tabs>>>.el-tabs__nav-wrap::after {
  background-color: #edf2ee;
}

.sub-tabs>>>.el-tabs__item {
  font-size: 18px;
  color: #55655b;
  height: 40px;
  line-height: 40px;
}

.sub-tabs>>>.el-tabs__item.is-active {
  color: #20863F;
  font-weight: 600;
}

.sub-tabs>>>.el-tabs__active-bar {
  background-color: #20863F;
}

/* 药品子表头 */
.drug-sub-header {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding-bottom: 16px;
  border-bottom: 1px solid #edf2ee;
  margin-bottom: 16px;
}

.drug-sub-title {
  font-size: 18px;
  font-weight: 700;
  color: #123b25;
  margin: 0;
}

.drug-sub-count {
  font-size: 14px;
  color: #718077;
  margin: 4px 0 0;
}

.drug-price-badge {
  display: inline-flex;
  align-items: center;
  padding: 8px 18px;
  border-radius: 9999px;
  background: #fff4e2;
  color: #b46700;
  font-size: 14px;
  font-weight: 600;
  white-space: nowrap;
}





/* ========== 伤寒方 ========== */
.shanghan-info {
  text-align: left;
  font-size: 18px;
  padding: 12px 0;
  font-family: 'Noto Sans SC', system-ui, sans-serif;
}

.shanghan-item {
  margin-bottom: 12px;
  color: #1f3327;
  font-family: 'Noto Sans SC', system-ui, sans-serif;
}

.shanghan-brief {
  word-wrap: break-word;
  white-space: pre-wrap;
  font-size: 18px;
  line-height: 1.7;
  color: #333;
  margin: 0;
  font-family: 'Noto Sans SC', system-ui, sans-serif;
}

/* ========== 针灸/健康预测：四角边框 ========== */
.info-content {
  margin: 8px 0;
}

.corner-borders {
  position: relative;
  background: #ffffff;
  border-radius: 24px;
  padding: 36px 24px;
  min-height: 60px;
}

@media (min-width: 768px) {
  .corner-borders {
    padding: 48px 40px;
  }
}

.corner {
  position: absolute;
  width: 56px;
  height: 56px;
  pointer-events: none;
}

.corner-lt {
  left: 16px;
  top: 16px;
  border-left: 4px solid #1f2937;
  border-top: 4px solid #1f2937;
}

.corner-rt {
  right: 16px;
  top: 16px;
  border-right: 4px solid #1f2937;
  border-top: 4px solid #1f2937;
}

.corner-lb {
  left: 16px;
  bottom: 16px;
  border-left: 4px solid #1f2937;
  border-bottom: 4px solid #1f2937;
}

.corner-rb {
  right: 16px;
  bottom: 16px;
  border-right: 4px solid #1f2937;
  border-bottom: 4px solid #1f2937;
}

.corner-inner {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}

.corner-inner p {
  text-align: left;
  line-height: 36px;
  font-size: 18px;
  margin: 10px 0;
  color: #0069bd;
}

/* ========== 症状信息折叠区 ========== */
.symptom-section {
  margin-top: 24px;
  margin-bottom: 24px;
}

.symptom-collapse {
  background: #ffffff;
  border: 1px solid #e0ebe4;
  border-radius: 32px;
  overflow: hidden;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.04);
}

.symptom-collapse>>>.el-collapse-item__header {
  height: 56px;
  padding: 0 28px;
  border-bottom: none;
  font-size: 16px;
  font-weight: 600;
  color: #1f3327;
  background: transparent;
}

.symptom-collapse>>>.el-collapse-item__wrap {
  border-bottom: none;
}

.symptom-collapse>>>.el-collapse-item__content {
  padding: 0 28px 24px;
}

.collapse-title-bar {
  display: flex;
  align-items: center;
  gap: 12px;
  width: 100%;
}

.collapse-accent {
  display: inline-block;
  width: 4px;
  height: 24px;
  border-radius: 2px;
  background: #20863F;
  flex-shrink: 0;
}

.collapse-title-text {
  font-size: 20px;
  font-weight: 700;
  color: #123b25;
  flex: 1;
}

.collapse-hint {
  font-size: 13px;
  color: #718077;
  font-weight: 400;
}

/* 症状分组 */
.symptom-list {
  display: flex;
  flex-direction: column;
  gap: 18px;
}

.symptom-group {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.symptom-group-title {
  font-size: 18px;
  font-weight: 700;
  color: #20863F;
  padding-left: 10px;
  line-height: 1.2;
}

.symptom-info-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 10px;
}

.symptom-info-grid .info-item {
  display: flex;
  align-items: center;
  border: 1px solid #edf0ec;
  border-radius: 8px;
  padding: 8px 12px;
  font-size: 15px;
  line-height: 1.5;
  background: #fff;
}

.symptom-info-grid .info-label {
  color: #1a1a1a;
  flex-shrink: 0;
  font-size: 18px;
  min-width: 130px;
}

.symptom-info-grid .info-value {
  color: #1a1a1a;
  font-size: 18px;
  word-break: break-all;
}

.sanjiao-list {
  display: flex;
  flex-direction: column;
  gap: 14px;
}

.sanjiao-group {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.sanjiao-group-title {
  font-size: 18px;
  font-weight: 600;
  color: #397152;
  padding-left: 8px;
  border-left: 2px solid #cde2d4;
  line-height: 1.2;
}

.divider {
  height: 1px;
  background: #edf0ec;
  margin: 4px 0;
}

@media (max-width: 640px) {
  .symptom-info-grid {
    grid-template-columns: 1fr;
  }
}

/* ========== 通用 ========== */
.text-muted {
  color: #aaa;
  font-size: 16px;
  padding: 20px 0;
  text-align: center;
}

.empty-tab {
  padding: 40px 0;
}

/* ========== 底部操作栏 ========== */
.bottom-actions {
  display: flex;
  flex-direction: column;
  gap: 16px;
  max-width: 520px;
  margin: 32px auto 0;
  padding: 0 0 12px;
}

@media (min-width: 640px) {
  .bottom-actions {
    flex-direction: row;
    max-width: 780px;
  }
}

.btn-bottom-draft {
  flex: 1;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  height: 48px;
  border-radius: 9999px;
  background: #1e90ff;
  border: 1px solid #1e90ff;
  color: #fff;
  font-size: 16px;
  font-weight: 700;
  cursor: pointer;
  transition: all 0.2s;
  box-shadow: 0 10px 22px rgba(30, 144, 255, 0.22);
}

.btn-bottom-draft:hover {
  background: #1873cc;
  border-color: #1873cc;
}

.btn-bottom-draft:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.btn-bottom-submit {
  flex: 1;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  height: 48px;
  border-radius: 9999px;
  background: #20863F;
  border: none;
  color: #fff;
  font-size: 16px;
  font-weight: 700;
  cursor: pointer;
  transition: all 0.2s;
  box-shadow: 0 10px 22px rgba(44, 132, 82, 0.22);
}

.btn-bottom-submit:hover {
  background: #257648;
  transform: translateY(-2px);
}

/* ========== 弹窗 ========== */
.dialog-radio-list {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 16px;
}

.dialog-radio {
  margin: 0;
  width: 100%;
}

.dialog-weight-row {
  display: flex;
  align-items: center;
  gap: 20px;
  justify-content: center;
}

.weight-drug-name {
  font-size: 16px;
  font-weight: 500;
}

/* ========== 响应式 ========== */
@media (max-width: 768px) {
  .page-container {
    padding: 20px 16px 60px;
  }

  .status-card {
    padding: 20px 24px;
    border-radius: 24px;
  }

  .status-title {
    font-size: 24px;
  }

  .basic-info-collapse,
  .tab-card {
    border-radius: 24px;
  }

  .tab-bar {
    padding: 8px;
    border-radius: 16px;
  }

  .tab-pill {
    padding: 8px 16px;
    font-size: 13px;
  }

  .corner {
    width: 36px;
    height: 36px;
  }

  .corner-lt {
    left: 8px;
    top: 8px;
  }

  .corner-rt {
    right: 8px;
    top: 8px;
  }

  .corner-lb {
    left: 8px;
    bottom: 8px;
  }

  .corner-rb {
    right: 8px;
    bottom: 8px;
  }

  .corner-borders {
    padding: 28px 16px;
  }
}
</style>
